<template>
  <div>
    <div class="row" v-if="editing">

      <div class="col-3">
        <label for="title-planning">{{ $t('ui.title') }}</label>
        <input type="text" id="title-planning" class="form-control" v-model="config.title">
      </div>
      <div class="col-xs-3">
        <label for="filter-on">Filter</label>
        <select name="" class="form-control" v-model="config.filterByKey" id="">
          <option :value="key" :key="key" v-for="key in getUniqueKeys">{{ getFormattedKey(key) }}</option>
        </select>
      </div>
    </div>


    <div class=row v-if="!editing">
      <div class="col-md-6 col-xs-12">
        <label for="filter-value" v-if="!editing"> Filter</label>
        <select name="filter-value" class="form-control" v-if=config.filterByKey v-model="config.filterByValue" id="">
          <option :value="null">{{$t('ui.all')}}</option>
          <option
              :value="value" :key="value" v-for="value in getUniqueValues">{{ getFormattedValue(value) }}
          </option>
        </select>
      </div>
      <div class="col-md-4 col-xs-12">
        <label for="filter-value" v-if="!editing">{{$t('insights.filters.downTimes.showOutplanned') }}</label>
        <select name="filter-value" class="form-control" v-model="config.filterDownTimeType" id="">
          <option :value="true">{{ $t('ui.yes') }}</option>
          <option :value="false">{{ $t('ui.no') }}</option>
        </select>
      </div>

    </div>
    <div class="chart-container ">
      <horizontal-bar-chart style="position: relative;width: 100%; height: 100%"
                            :chartData="getChartData"
                            :options="getOptions"/>
    </div>

  </div>


</template>

<script>
import HorizontalBarChart from '@/components/insights/charts/horizontalBarChart.js'

import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import chartColors from "@/mixins/insights/chartColors";

export default {
  components: {
    HorizontalBarChart
  },
  mixins: [timeCalc, generalMethods, chartColors],
  props: ['editing'],
  data() {
    return {
      downTimes: [],
      config: {
        weekDifference: 0,
        filterByKey: null,
        filterByValue: null
      }
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    getDownTimes() {
      let downTimes = this.downTimes
      if (this.config.filterByValue) {
        return this.getFilteredDownTimes
      }
       return downTimes
    },
    getFilteredDownTimes() {
      return _.filter(this.downTimes, dt => {
        return dt[this.config.filterByKey] === this.config.filterByValue
      })
    },
    getOptions() {
      const self = this
      return {
        ...this.generalChartOptions,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {

              gridLines: {
                display: false
              },
            },
          ],
          xAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function (label, index, labels) {
                return self.formattedColonTime(label, false) + 'u'
              }
            }
          }],
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return tooltip[0].label
            },
            label: function (tooltipItem) {
              return self.formattedColonTime(tooltipItem.value) + 'u'    //tooltipItem.value
            }
          }
        },
        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 20
            },
            offset: -50,

            display: function (ctx) {
              return false
              return ctx.datasetIndex > 0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
              return self.getHoursFromMilliseconds(value.y, false) > 0 ? self.getHoursFromMilliseconds(value.y, false) + '' : ' '
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }

    },
    getUniqueKeys() {
      return this.getUniqueDownTimeKeys();
    },
    getUniqueValues() {
      // return _.uniq(_.map(this.downTimes, this.config.filterByKey)).sort();

      // should loop and get values if type
      let mappedValues = _.map(this.downTimes, (dt) => {
        if (dt[this.config.filterByKey] && dt[this.config.filterByKey].length && typeof dt[this.config.filterByKey] == "object") {
          return _.uniq(dt[this.config.filterByKey])
        }
        return dt[this.config.filterByKey]
      })
      let res = _.flattenDeep(mappedValues).filter(val => {
        return val
      })

      return [...new Set(res)].sort();

    },
    getUniqueReasons() {
      const self = this
      return [...new Set(self.downTimes.map(dt => {
            try {
              if (dt.reason) {
                return dt.reason.join('|')
              }
            } catch (e) {

            }
          }
      ))].filter(Boolean)
    },

    getChartData() {
      let labels = this.getUniqueReasons
      let datasets = [
        {
          label: 'Reasons',
          backgroundColor: '#DD872E',//this.colors.downTimes.reasons,
          data: new Array(labels.length).fill(0)
        }]

      _.each(this.getDownTimes, dt => {
        // Filters out all the out planned downtimes
        // for example during weekends or nights
         if (!this.config.filterDownTimeType && dt.planned) {
          return
        }
        if (dt.downTimeEnded) {
          let diff = moment(dt.downTimeEnded.toDate()).diff(dt.downTimeIndicator.toDate())
          let index = _.findIndex(labels, label => {
            // reasons seperated by pipeline
            if (dt.reason) {
              return label === dt.reason.join('|')
            }
          })
          if (index >= 0) {
            datasets[0].data[index] += diff
          } else {
            datasets[0].data[index] = diff
          }
          // get index of label
        }
      })

      const arrayOfObj = labels.map(function (d, i) {
        return {
          label: d,
          data: datasets[0].data[i],
        }
      })

      const sortedArrayOfObj = arrayOfObj.sort(function (a, b) {
        return b.data - a.data
      })

      let newArrayLabel = []
      let newArrayData = []
      sortedArrayOfObj.forEach(function (d) {
        if (d.data > 0) {
          newArrayLabel.push(d.label)
          newArrayData.push(d.data)
        }
      })
      datasets[0].data = newArrayData
      return {
        labels: newArrayLabel,
        datasets,
      }
    },
  },
  methods: {
    async getDownTimesFromFilter() {
      let userClaims = this.getClaims
      let time = moment().startOf('week').add(parseInt(this.config.weekDifference), 'week')
      time = moment().startOf('week').add(-3, 'week')
      try {
        let downTimes = (await this.$FBClient.firestore().collection('downTimes')
            .where('companyId', '==', userClaims.companyId)
            .where('downTimeIndicator', '>=', time.toDate())
            // .where('planned','==',false)
            .where('downTimeIndicator', '<=', moment().endOf('week').toDate())
            .get()).docs.map(doc => {
          return doc.data()
        })
        this.downTimes = downTimes
      } catch (e) {
        console.log(e)
      }
      return false
    }
  },
  watch: {
    weekDifference() {
      this.getDownTimesFromFilter()
    },
    'config.filterDownTimeType'() {
    }
  },
  created() {
    this.getDownTimesFromFilter()
  }
}
</script>


<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";
</style>